import type { AppAuthConfig } from '@new-cti/frontend-shared/auth/config';

// cast アプリの認証/API 設定（共有モジュールへ注入する唯一のアプリ差分）。
export const appConfig: AppAuthConfig = {
  basePath: '/cast',
  apiPrefix: '/api/cast',
};
